import Litepicker from 'litepicker';

/* global ParamsData */
export default contactForm => {
    // console.log('contactForm');
    const form = contactForm;
    const dataAction = form.getAttribute('data-action');
    const dataNonce = form.getAttribute('data-nonce');
    const formSubmit = form.querySelector('input[type="submit"]');
    const formFields = form.querySelectorAll(':required');
    const inputDate = form.querySelector('#input-date');
    // const inputTextCaptcha = form.querySelector('#input-text-captcha');
    let init = true;
    let validity = true;
    // let captchaSolved = false;

    const inputDestination = form.querySelector('#field-destination');
    const inputHotel = form.querySelector('#field-hotelid');
    const blocGolfs = form.querySelector('.row-field-golfs');
    const inputType = form.querySelector('#field-type');


    const inputDatePicker = form.querySelector('#field-dates');


    function formFieldsValidate() {
        if (init === true) return;

        validity = true;

        for (const field of formFields) {
            const msg = field.parentNode.querySelector('.message-error');

            if (!field.checkValidity() || (field.type == "email" && !validateEmail(field.value))) {
                field.parentNode.classList.add('error');
                msg.innerHTML = field.getAttribute('data-message');
                validity = false;
            } else {
                field.parentNode.classList.remove('error');
                // msg.innerHTML = '';
            }
        }

        // eslint-disable-next-line consistent-return
        return validity;
    }

    function validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    // function captchaValidate() {
    //     if (inputTextCaptcha.value === '3R7AA') {
    //         captchaSolved = true;
    //         inputTextCaptcha.parentNode.classList.remove('error');
    //     } else {
    //         captchaSolved = false;
    //         inputTextCaptcha.parentNode.classList.add('error');
    //     }

    //     return captchaSolved;
    // }

    function addErrorMessage() {
        for (const field of formFields) {
            const msg = document.createElement('span');
            msg.classList.add('message-error');
            field.parentNode.appendChild(msg);
            field.addEventListener('change', formFieldsValidate);
        }
    }

    function sendAjax(ajaxData) {
        const request = new XMLHttpRequest();
        const ajaxUrl = ParamsData.wp_ajax_url;

        request.open('POST', ajaxUrl, true);
        request.send(ajaxData);

        request.responseType = 'json';

        request.onprogress = () => {
            //console.log('loading...');
        };

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }

            if (response.status === 200) {
                //console.log('ok');
            } else {
                //console.log(response.message);
            }
        };

        request.onerror = () => {
            //console.log('error...');
        };
    }

    addErrorMessage();

    // if(inputTextCaptcha != null){
    //   inputTextCaptcha.addEventListener('change', captchaValidate);
    // }

    formSubmit.addEventListener('click', event => {


        init = false;

        if (!formFieldsValidate()) {
            event.preventDefault();
        } 
        //  else if (!captchaSolved) {
        //     captchaValidate();
        //     event.preventDefault();
        // } 
        else {

            let formType = form.dataset.form;

            switch (formType) {
                case 'contact':
                    gtag('event', 'formulaire', {'event_category' : 'contact','event_label' : 'page-contact'});
                    break;
                case 'golf-managment':
                    gtag('event', 'formulaire', {'event_category' : 'contact','event_label' : 'golf-service-management'});
                break;
                case 'reservation-hors-offre':
                    gtag('event', 'formulaire', {'event_category' : 'contact','event_label' : 'reserver-sejour'});
                break;
                default:
                    gtag('event', 'formulaire', {'event_category' : 'contact','event_label' : formType});
                break;
            }

            /*console.log('form ok');
            console.log('captche ok');

            console.log('dataAction', dataAction);
            console.log('dataNonce', dataNonce);

            const ajaxData = new FormData();
            const inputRadioGender = form.querySelector('input[name="input-radio-gender"]:checked');
            const inputTextName = form.querySelector('#input-text-name');
            const inputTextFirstname = form.querySelector('#input-text-firstname');
            const inputTextCompany = form.querySelector('#input-text-company');
            const inputTextAddress = form.querySelector('#input-text-address');
            const inputTextZipcode = form.querySelector('#input-text-zipcode');
            const inputTextCity = form.querySelector('#input-text-city');
            const inputTextEmail = form.querySelector('#input-text-email');
            const selectRequest = form.querySelector('#select-request');
            const inputsCheckboxGolf = form.querySelectorAll('input[name="input-checkbox-golf"]');
            const textAreaMessage = form.querySelector('#textarea-message');
            const selectKnowledge = form.querySelector('#select-knowledge');
            const inputNewsletter = form.querySelector('#input-checkbox-newsletter');

            ajaxData.append('action', dataAction);
            ajaxData.append('nonce', dataNonce);

            if (inputRadioGender !== null) {
                console.log('Gender', inputRadioGender.value);
                ajaxData.append('Gender', inputRadioGender.value);
            }

            if (inputTextName.value !== '') {
                console.log('Name', inputTextName.value);
                ajaxData.append('Name', inputTextName.value);
            }

            if (inputTextFirstname.value !== '') {
                console.log('Firstname', inputTextFirstname.value);
                ajaxData.append('Firstname', inputTextFirstname.value);
            }

            if (inputTextCompany.value !== '') {
                console.log('Company', inputTextCompany.value);
                ajaxData.append('Company', inputTextCompany.value);
            }

            if (inputTextAddress.value !== '') {
                console.log('Address', inputTextAddress.value);
                ajaxData.append('Address', inputTextAddress.value);
            }

            if (inputTextZipcode.value !== '') {
                console.log('Zipcode', inputTextZipcode.value);
                ajaxData.append('Zipcode', inputTextZipcode.value);
            }

            if (inputTextCity.value !== '') {
                console.log('City', inputTextCity.value);
                ajaxData.append('City', inputTextCity.value);
            }

            if (inputTextEmail.value !== '') {
                console.log('Email', inputTextEmail.value);
                ajaxData.append('Email', inputTextEmail.value);
            }

            if (selectRequest.options[selectRequest.selectedIndex].value !== '') {
                console.log('Request', selectRequest.options[selectRequest.selectedIndex].value);
                ajaxData.append('Request', selectRequest.options[selectRequest.selectedIndex].value);
            }

            const inputsCheckboxGolfValues = [];

            for (const inputCheckboxGolf of inputsCheckboxGolf) {
                if (inputCheckboxGolf.checked) {
                    inputsCheckboxGolfValues.push(inputCheckboxGolf.value);
                }
            }

            if (inputsCheckboxGolfValues.length > 0) {
                console.log('Golf', inputsCheckboxGolfValues);
                ajaxData.append('Golf', inputsCheckboxGolfValues);
            }

            // if (inputDate.value !== '') {
            console.log('inputDate', inputDate.value);
            // }

            if (textAreaMessage.value !== '') {
                console.log('Message', textAreaMessage.value);
                ajaxData.append('Message', textAreaMessage.value);
            }

            if (selectKnowledge.options[selectKnowledge.selectedIndex].value !== '') {
                console.log('Knowledge', selectKnowledge.options[selectKnowledge.selectedIndex].value);
                ajaxData.append('Knowledge', selectKnowledge.options[selectKnowledge.selectedIndex].value);
            }

            if (inputNewsletter.checked) {
                console.log('Newsletter', inputNewsletter.value);
                ajaxData.append('Newsletter', inputNewsletter.value);
            }

            sendAjax(ajaxData);*/
        }
    });

    if(inputDestination != null && blocGolfs != null){

      if(inputDestination.value == ""){
        blocGolfs.style.display = "none";
        form.querySelector('.subtitle-field-golfs').style.display = "none";
      }

      inputDestination.addEventListener('change', function(){

        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', 'form_golf');
        ajaxData.append('destination', inputDestination.value);
        ajaxData.append('type', inputType.value);
        request.open('POST', url, true);
        request.send(ajaxData);
        blocGolfs.classList.add('loading');

        if(inputDestination.value != ""){
          blocGolfs.style.display = "flex";
          form.querySelector('.subtitle-field-golfs').style.display = "block";
        }else{
          blocGolfs.style.display = "none";
          form.querySelector('.subtitle-field-golfs').style.display = "none";
        }

        request.onprogress = () => {
        };

        request.onload = () => {
            let response = request.response;
            blocGolfs.innerHTML = response;
            blocGolfs.classList.remove('loading');

        };

        request.onerror = () => {
            // console.log('onerror...');
        };

      });
    }

    if(inputDestination != null && inputHotel != null){


      inputDestination.addEventListener('change', function(){

        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', 'form_hotels');
        ajaxData.append('destination', inputDestination.value);
        ajaxData.append('previoushotel', inputHotel.value);
        ajaxData.append('type', inputType.value);
        request.open('POST', url, true);
        request.send(ajaxData);
        inputHotel.parentNode.classList.add('loading');

        request.onprogress = () => {
        };

        request.onload = () => {
            let response = request.response;
            inputHotel.innerHTML = response;
            inputHotel.parentNode.classList.remove('loading');
        };

        request.onerror = () => {
            // console.log('onerror...');
        };

      });
    }

    if(inputHotel != null && blocGolfs != null){

      if(inputHotel.value == ""){
        blocGolfs.style.display = "none";
        form.querySelector('.subtitle-field-golfs').style.display = "none";
      }

      inputHotel.addEventListener('change', function(){

        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', 'form_golf');
        ajaxData.append('hotel', inputHotel.value);
        ajaxData.append('type', inputType.value);
        if(inputDestination != null){
          ajaxData.append('destination', inputDestination.value);
        }
        request.open('POST', url, true);
        request.send(ajaxData);
        blocGolfs.classList.add('loading');

        request.onprogress = () => {
        };

        request.onload = () => {
            let response = request.response;
            blocGolfs.innerHTML = response;
            blocGolfs.classList.remove('loading');

            if(response == ""){
              blocGolfs.style.display = "none";
              form.querySelector('.subtitle-field-golfs').style.display = "none";
            }else{
              blocGolfs.style.display = "flex";
              form.querySelector('.subtitle-field-golfs').style.display = "block";
            }

        };

        request.onerror = () => {
            // console.log('onerror...');
        };

      });
    }


    if(inputDatePicker != null){
      var initDates = inputDatePicker.value;

      var paramsPicker = {
          element: inputDatePicker,
          firstDay: 1,
          format: 'DD/MM/YYYY',
          bookedDaysFormat: 'DD/MM/YYYY',
          lang: 'fr-FR',
          numberOfMonths: 2,
          numberOfColumns: 2,
          singleMode: false,
          autoApply: true,
          parentEl: inputDatePicker.parentNode,
          // autoApply: false,
          onShow: function(){

              // Calculate if Calendar needs to be shown above the Date field
              let picker = document.querySelector('.litepicker');
              let bounds = picker.getBoundingClientRect();
              let vh = window.innerHeight;

              if( vh < bounds.bottom ){
                  document.querySelector('.litepicker').classList.add('above');
              }
          },
          onHide: function(){
              // Remove 'Above' class
              document.querySelector('.litepicker').classList.remove('above');
          }
      };
      if(inputDatePicker.dataset.mindate != "" && inputDatePicker.dataset.mindate != undefined){
        let dateminArray = inputDatePicker.dataset.mindate.split('/');
        paramsPicker.minDate = new Date(dateminArray[2], dateminArray[1] - 1, dateminArray[0]);
      }
      if(inputDatePicker.dataset.maxdate != "" && inputDatePicker.dataset.maxdate != undefined){
        let datemaxArray = inputDatePicker.dataset.maxdate.split('/');
        paramsPicker.maxDate = new Date(datemaxArray[2], datemaxArray[1] - 1, datemaxArray[0]);
      }
      const datePicker = new Litepicker(paramsPicker);
      if(initDates != ""){
        var initDatesArray = initDates.split(' - ');
        if(initDatesArray.length == 2){
          datePicker.setDateRange(initDatesArray[0], initDatesArray[1]);
        }
      }

    }

};
